import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface CartContextDef {
  openModal?: OpenCart;
  openConfirmCloseModal?: boolean;
  setOpenModal?: Dispatch<SetStateAction<OpenCart | undefined>>;
  setOpenConfirmDraftOrderModal?: Dispatch<SetStateAction<boolean | undefined>>;
}

export const CartContext = createContext<CartContextDef>({});

export const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('component is not inside CartContext');
  }
  return context;
};

const useStatesAndActions = (): CartContextDef => {
  const [openModal, setOpenModal] = useState<OpenCart | undefined>();
  const [openConfirmCloseModal, setOpenConfirmDraftOrderModal] =
    useState<boolean>();

  return {
    openModal,
    openConfirmCloseModal,
    setOpenModal,
    setOpenConfirmDraftOrderModal,
  };
};

export const CartProvider = ({ children }: { children: React.ReactNode }) => (
  <CartContext.Provider value={useStatesAndActions()}>
    {children}
  </CartContext.Provider>
);

export type OpenCart = OpenCreateCart | EditCart | ViewCart;

export type OpenCreateCart = {
  type: 'create';
};

export type EditCart = {
  type: 'edit';
  cartId: string;
  cartNumber: string;
};

export type ViewCart = {
  type: 'view';
  cartId: string;
  cartNumber: string;
};
